import { FormControlLabel, Checkbox as CheckboxMui, Typography, Tooltip, Grid2 } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { disabledColor } from 'utils/constants/ColorTheme'
import { isNil } from 'lodash'

const SimpleCheckbox = ({
    checked = false,
    onToggle = () => {},
    label = '',
    labelStyle = {},
    checboxStyle = {},
    tooltip,
    disabled,
    beforeLabel,
    afterLabel,
    'data-cy': dataCy,
}) => {
    const checkbox = (
        <FormControlLabel
            data-cy={dataCy}
            control={(
                <CheckboxMui
                    checked={checked}
                    color='third'
                    onChange={onToggle}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={{
                        '& .MuiSvgIcon-root': {
                            fontSize: '2rem',
                            ...checboxStyle,
                        },
                    }}
                    disabled={disabled}
                />
            )}
            label={(
                <Grid2 container alignItems='center' columnSpacing={1}>
                    {!!beforeLabel && beforeLabel}
                    <Typography
                        sx={{
                            color: disabled ? `${disabledColor} !important` : '#161832 !important',
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            ...labelStyle,
                        }}
                    >
                        {label}
                    </Typography>
                    {!!afterLabel && afterLabel}
                </Grid2>
            )}
            sx={{
                '& .MuiButtonBase-root': {
                    padding: '0 9px',
                },
            }}
        />
    )
    return isNil(tooltip) ? checkbox : <Tooltip title={tooltip}>{checkbox}</Tooltip>
}

SimpleCheckbox.propTypes = {
    checked: PropTypes.bool,
    onToggle: PropTypes.func,
    label: PropTypes.string,
    labelStyle: PropTypes.shape({}),
    checboxStyle: PropTypes.shape({}),
    tooltip: PropTypes.string,
    disabled: PropTypes.bool,
    beforeLabel: PropTypes.element,
    afterLabel: PropTypes.element,
    'data-cy': PropTypes.string,
}

export default SimpleCheckbox
